var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 3.10493C20 4.88693 20 8.60693 20 8.60693C20 8.60693 20 12.3269 19.543 14.1089C19.289 15.0939 18.546 15.8689 17.605 16.1309C15.896 16.6069 10 16.6069 10 16.6069C10 16.6069 4.107 16.6069 2.395 16.1309C1.45 15.8649 0.708 15.0909 0.457 14.1089C2.98023e-08 12.3269 0 8.60693 0 8.60693C0 8.60693 2.98023e-08 4.88693 0.457 3.10493C0.711 2.11993 1.454 1.34493 2.395 1.08293C4.107 0.606933 10 0.606934 10 0.606934C10 0.606934 15.896 0.606933 17.605 1.08293C18.55 1.34893 19.292 2.12293 19.543 3.10493ZM8 12.1069L14 8.60693L8 5.10693V12.1069Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b595def37b09069b3b6742f86bdb4b4b.svg";
export { ForwardRef as ReactComponent };